'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _mobileDetect = require('mobile-detect');

var _mobileDetect2 = _interopRequireDefault(_mobileDetect);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var md = new _mobileDetect2.default(window.navigator.userAgent);

md.isPhone = function () {
    var phone = md.phone();
    return phone && phone !== 'UnknownMobile';
};

exports.default = md;


//////////////////
// WEBPACK FOOTER
// ./~/rp-gui-guide/lib/js/mobile-detect-instance.js
// module id = 1511
// module chunks = 1